import {
  Advice,
  AdvicePriceCalculationRequest,
  AdvicePriceCalculationResult,
} from "Store/advice/interfaces";
import {
  AdviceProductDetailsFormValues,
  AdvisorValues,
} from "../../ProductDetails/FormElements/interfaces";

import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { ADVICE_YOUR_LIFE_SITUATION_STEP } from "../../adviceSteps";

export const useAdviceResult = (): Advice | null =>
  useSelector((state: ReduxState) => state.advice.adviceResult.current);

export const useAdvicePriceCalculationRequests =
  (): AdvicePriceCalculationRequest =>
    useSelector(
      (state: ReduxState) => state.advice.advicePriceCalculationRequests,
    );

export const useAdvicePriceCalculationResults = ():
  | AdvicePriceCalculationResult[]
  | null =>
  useSelector(
    (state: ReduxState) => state.advice.advicePriceCalculationResults.current,
  );

export const useIsAdvicePriceLoading = (): boolean =>
  useSelector(
    (state: ReduxState) => state.advice.advicePriceCalculationResults.isLoading,
  );

export const useAdvisorValues = (): AdvisorValues | undefined =>
  useSelector(
    (state: ReduxState) =>
      state.cart.current?.advice?.adviceProductValues?.advisorValues,
  );

export const useAdviceDetailsFormValues = ():
  | AdviceProductDetailsFormValues
  | undefined =>
  useSelector(
    (state: ReduxState) =>
      state.priceCalculation.priceCalculationFormStates[
        ADVICE_YOUR_LIFE_SITUATION_STEP.id
      ] as AdviceProductDetailsFormValues,
  );
